/* La Collection Gourmande — theme.js
   Cart AJAX (Shopify Ajax API), variant switching, gallery, quantity.
   Checkout is always handled by Shopify (/cart -> /checkout) so Shopify Payments,
   Shop Pay, OXXO, SPEI and MSI stay fully functional. */

(function () {
  'use strict';

  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return moneyFormat.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, amount);
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); renderCart().then(openDrawer); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function renderCart() {
    return fetchJSON('/cart.js').then(function (cart) {
      var body = document.querySelector('[data-cart-body]');
      var counters = document.querySelectorAll('[data-cart-count]');
      counters.forEach(function (el) { el.textContent = cart.item_count; });

      if (!body) return cart;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<p>' + (window.themeStrings.cartEmpty) + '</p>' +
          '<a class="btn btn--outline btn--full" href="/collections/all">' + window.themeStrings.continueShopping + '</a>';
        return cart;
      }

      var html = cart.items.map(function (item) {
        return '' +
          '<div class="cart-line">' +
            '<img src="' + (item.image ? item.image.replace(/(\.[^.]*)$/, '_128x$1') : '') + '" alt="" width="64" height="64">' +
            '<div>' +
              '<div class="cart-line__title">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '') +
              '<div class="cart-line__meta">' + window.themeStrings.quantity + ': ' + item.quantity +
              ' · <button type="button" class="link-btn" data-cart-remove="' + item.key + '">' + window.themeStrings.remove + '</button></div>' +
            '</div>' +
            '<div>' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');

      html += '' +
        '<form action="/cart" method="post" novalidate class="cart-foot">' +
          '<div class="cart-foot__row"><span>' + window.themeStrings.subtotal + '</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
          '<p class="cart-line__meta" style="margin:0">' + window.themeStrings.taxesNote + '</p>' +
          '<button type="submit" name="checkout" class="btn btn--primary btn--full btn--lg">' + window.themeStrings.checkout + '</button>' +
          '<a class="btn btn--outline btn--full" href="/cart">' + window.themeStrings.viewCart + '</a>' +
        '</form>';

      body.innerHTML = html;
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    e.preventDefault();
    var updates = {};
    updates[removeBtn.getAttribute('data-cart-remove')] = 0;
    fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(renderCart);
  });

  /* ---------------- Quantity ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(btn.getAttribute('data-qty'), 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Product form (AJAX add) ---------------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.cartType !== 'drawer') return; // let Shopify handle full page
      e.preventDefault();
      var submit = form.querySelector('[data-add-button]');
      var original = submit ? submit.textContent : '';
      if (submit) { submit.setAttribute('aria-disabled', 'true'); submit.textContent = '…'; }

      fetchJSON('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function () { return renderCart(); })
        .then(openDrawer)
        .catch(function (err) {
          var status = form.querySelector('[data-form-status]');
          if (status) {
            status.hidden = false;
            status.classList.add('form-status--error');
            status.textContent = (err && err.description) || 'Error';
          }
        })
        .finally(function () {
          if (submit) { submit.removeAttribute('aria-disabled'); submit.textContent = original; }
        });
    });
  });

  /* ---------------- Variant selection ---------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    var data = JSON.parse(document.getElementById(picker.dataset.variantPicker).textContent);

    function currentOptions() {
      return Array.from(picker.querySelectorAll('input:checked')).map(function (i) { return i.value; });
    }

    picker.addEventListener('change', function () {
      var selected = currentOptions();
      var variant = data.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });

      var idInput = form.querySelector('input[name="id"]');
      var addBtn = form.querySelector('[data-add-button]');
      var priceEl = document.querySelector('[data-price-current]');
      var compareEl = document.querySelector('[data-price-compare]');

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.themeStrings.unavailable; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    });
  });

  /* ---------------- Gallery ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.galleryThumb;
        main.srcset = thumb.dataset.gallerySrcset || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Initial count */
  if (document.querySelector('[data-cart-count]')) { renderCart(); }
})();
